
import webApi from './webApi'


const basePath = 'vipHosts'

const vipHostService = {
    fetchAll : async()=>{
        return await webApi.httpGet(basePath)
    },
    
    fetch : async(id)=>{
        return await webApi.httpGet(basePath+'/'+id)
    },

    create : async(vh)=>{
        return await webApi.httpPost(basePath, vh)
    },
    update : async(vh)=>{
        return await webApi.httpPut(basePath, vh)
    },

    delete : async(id)=>{
        return await webApi.httpDelete(basePath+'/'+id)
         
    },
}



export default vipHostService

